export const defaultChartThemeConfig = {
  chart: {
    background: "transparent",
    dropShadow: {
      blur: 5,
      color: "#000000",
      enabled: false,
      left: 0,
      opacity: 0.5,
      top: 0
    },
    foreColor: "#000000",
    toolbar: {
      show: false
    },
    zoom: false,
    events: {}
  },
  colors: [],
  dataLabels: {
    background: {
      dropShadow: {}
    },
    enabled: false,
    style: {
      fontWeight: 700
    }
  },
  fill: {
    gradient: {
      colorStops: [],
      inverseColors: false
    }
  },
  grid: {
    padding: {
      left: 15,
      right: 25
    },
    show: true,
    yaxis: {
      lines: {
        show: true
      }
    }
  },
  legend: {
    clusterGroupedSeries: true,
    clusterGroupedSeriesOrientation: "vertical",
    fontSize: 14,
    itemMargin: {
      vertical: 0
    },
    markers: {
      shape: "square",
      size: 7
    },
    offsetY: 0,
    show: true
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
      borderRadiusWhenStacked: "last",
      dataLabels: {
        total: {
          enabled: false,
          offsetX: 0,
          offsetY: 0,
          style: {
            color: "#373d3f",
            fontSize: "12px",
            fontWeight: 600
          }
        }
      },
      hideZeroBarsWhenGrouped: false,
      isDumbbell: false,
      isFunnel: false,
      isFunnel3d: true
    },
    bubble: {
      zScaling: true
    },
    line: {
      colors: {
        threshold: 0
      },
      isSlopeChart: false
    },
    pie: {
      donut: {
        labels: {
          name: {},
          total: {},
          value: {}
        }
      }
    },
    radialBar: {
      barLabels: {
        enabled: false,
        fontSize: "16px",
        fontWeight: 600,
        offsetX: 0,
        offsetY: 0,
        useSeriesColors: true
      },
      dataLabels: {
        name: {},
        total: {},
        value: {}
      },
      hollow: {
        background: "#fff"
      }
    },
    treemap: {
      borderRadius: 4,
      dataLabels: {
        format: "scale"
      },
      seriesTitle: {
        borderColor: "#000",
        borderRadius: 2,
        borderWidth: 1,
        offsetX: 1,
        offsetY: 1,
        show: true,
        style: {
          background: "rgba(0, 0, 0, 0.6)",
          color: "#fff",
          cssClass: "",
          fontSize: "12px",
          fontWeight: 400,
          padding: {
            bottom: 2,
            left: 6,
            right: 6,
            top: 2
          }
        }
      }
    }
  },
  stroke: {
    fill: {
      gradient: {},
      opacity: 0.85,
      type: ""
    },
    show: true
  },
  theme: {
    mode: "light",
    palette: "palette1"
  },
  xaxis: {
    axisBorder: {
      show: true
    },
    axisTicks: {
      show: true
    },
    crosshairs: {
      show: false
    },
    labels: {
      offsetX: 0,
      offsetY: 0,
      rotate: -45,
      show: true,
      style: {},
      trim: true
    },
    offsetY: 0,
    position: "bottom",
    title: {
      style: {
        fontSize: "12px"
      }
    },
    tooltip: {
      enabled: false
    },
    type: "numeric",
    convertedCatToNumeric: false,
    categories: [],
    tickAmount: "dataPoints"
  },
  yaxis: {
    crosshairs: {
      show: false
    },
    labels: {
      show: true,
      showDuplicates: false,
      style: {}
    },
    show: true,
    tickAmount: 5,
    title: {
      style: {
        fontSize: "12px"
      }
    }
  }
};

export const getChartOptions = (chartType, data) => {
  const normalizedType = chartType === "doughnut" ? "donut" : chartType;

  const baseOptions = {
    chart: {
      type: normalizedType,
      height: 350,
      width: "100%",
      toolbar: {
        show: true
      },
      background: "transparent",
      animations: {
        enabled: true
      }
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      labels: {
        colors: "var(--bs-text-default)",
        useSeriesColor: false
      },
      markers: {
        width: 12,
        height: 12,
        strokeWidth: 0,
        radius: 5,
        offsetX: -5
      }
    },
    theme: {
      palette: "palette1"
    }
  };

  switch (normalizedType) {
    case "bar":
      return {
        ...baseOptions,
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "35%",
            distributed: false,
            borderRadius: 0,
            strokeWidth: 0
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["var(--bs-text-default)"]
          },
          background: {
            enabled: false // Disable background
          },
          dropShadow: {
            enabled: false // Disable shadow
          }
        },
        xaxis: {
          categories: data.labels || [],
          title: {
            text: "Categories",
            style: {
              color: "var(--bs-text-default)"
            }
          },
          labels: {
            style: {
              colors: "var(--bs-text-default)"
            }
          }
        },
        yaxis: {
          title: {
            text: "Values",
            style: {
              color: "var(--bs-text-default)"
            }
          },
          labels: {
            style: {
              colors: "var(--bs-text-default)"
            }
          }
        }
      };
    case "pie":
    case "donut":
      return {
        ...baseOptions,
        labels: data.labels || [],
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              size: "65%",
              background: "transparent",
              labels: {
                show: false,
                name: {
                  show: true,
                  color: "var(--bs-text-default)"
                },
                value: {
                  show: true,
                  color: "var(--bs-text-default)"
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["var(--bs-text-default)"]
          },
          background: {
            enabled: false // Disable background
          },
          dropShadow: {
            enabled: false // Disable shadow
          }
        },
        stroke: {
          width: 0
        }
      };
    case "line":
      return {
        ...baseOptions,
        stroke: {
          show: true,
          width: 3,
          curve: "smooth",
          colors: undefined
        },
        markers: {
          size: 5,
          colors: undefined,
          strokeWidth: 0
        },
        xaxis: {
          categories: data.labels || [],
          title: {
            text: "Time Period",
            style: {
              color: "var(--bs-text-default)"
            }
          },
          labels: {
            style: {
              colors: "var(--bs-text-default)"
            }
          }
        },
        yaxis: {
          title: {
            text: "Values",
            style: {
              color: "var(--bs-text-default)"
            }
          },
          labels: {
            style: {
              colors: "var(--bs-text-default)"
            }
          }
        },
        dataLabels: {
          enabled: false,
          style: {
            colors: ["#202020"]
          },
          background: {
            enabled: false // Disable background
          },
          dropShadow: {
            enabled: false // Disable shadow
          }
        }
      };
    case "polarArea":
      return {
        ...baseOptions,
        labels: data.labels || [],
        plotOptions: {
          polarArea: {
            rings: {
              strokeWidth: 1,
              strokeColor: "#fff"
            },
            spokes: {
              strokeWidth: 1,
              connectorColors: "#fff"
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fff"]
          },
          background: {
            enabled: false // Disable background
          },
          dropShadow: {
            enabled: false // Disable shadow
          }
        },
        stroke: {
          width: 0
        }
      };
    default:
      return baseOptions;
  }
};

export const formatChartData = (chartData) => {
  if (!chartData) return null;

  const { data, type, name } = chartData;
  const normalizedType = type === "doughnut" ? "donut" : type;

  if (normalizedType === "pie" || normalizedType === "donut" || normalizedType === "polarArea") {
    return {
      options: {
        ...getChartOptions(normalizedType, data),
        title: {
          text: name || "",
          align: "center",
          style: {
            color: "var(--bs-text-default)"
          }
        }
      },
      series: data.series,
      type: normalizedType
    };
  }

  if (normalizedType === "line") {
    return {
      options: {
        ...getChartOptions(normalizedType, data),
        title: {
          text: name || "",
          align: "center",
          style: {
            color: "var(--bs-text-default)"
          }
        },
        xaxis: {
          categories: data.labels || []
        }
      },
      series: [
        {
          name: data.group_by || "Value",
          data: data.series
        }
      ],
      type: normalizedType
    };
  }

  return {
    options: {
      ...getChartOptions(normalizedType, data),
      title: {
        text: name || "",
        align: "center",
        style: {
          color: "var(--bs-text-default)"
        }
      }
    },
    series: [
      {
        name: data.group_by || "Value",
        data: data.series
      }
    ],
    type: normalizedType
  };
};
